import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	Input
} from '@angular/core';

import { VgStates } from '../VgStates';

import styles from './VgPoster.module.less';

@Component({
	selector: 'vg-poster',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		'[class]': 'styles.root'
	},
	template: `
		<img
			[ngClass]="styles.image"
			*ngIf="vgUrl"
			[hidden]="!isStopped"
			[src]="vgUrl"
			role="presentation"
			alt="">
	`,
    standalone: false
})
export class VgPosterComponent {
	@Input() public currentState: VgStates;
	@Input() public vgUrl: string;

	public readonly styles = styles;

	@HostBinding('class.vgPosterRootStopped')
	public get isStopped(): boolean {
		return this.currentState === VgStates.STOP;
	}
}
